import React, {useContext, useEffect, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Draggable from 'react-draggable';
import Paper from '@mui/material/Paper';
import { AuthContext } from '../../../contexts/authContext';
import config from '../../../config';
import axios from 'axios';
import { TextField } from '@mui/material';
import { inputOnlyNumbers } from '../../../utils/CommonUtilities';
import useNotification from '../../../hooks/useNotification';

function PaperComponent(props) {
    const nodeRef = React.useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

function ManageFermateDialog(props) {
    const auth = useContext(AuthContext)
    const { notificationSuccess, notificationError } = useNotification();
    const [idEntita, setIdEntita] = useState('');
    const [city, setCity] = useState('');
    const [nome, setNome] = useState('');
    const [navilens, setNavilens] = useState('');

    const [originalNome, setOriginalNome] = useState('');
    const [originalNavilens, setOriginalNavilens] = useState('');

    useEffect(() => {
        async function init(){
            if(props.openManageFermateDialog==='mod'){
                setIdEntita(props.lastCellData?.idEntita.S);
                setCity(props.lastCellData?.city.S);
                setNome(props.lastCellData?.nome.S);
                setNavilens(props.lastCellData?.navilens?.S);
                

                setOriginalNome(props.lastCellData?.nome.S);
                setOriginalNavilens(props.lastCellData?.navilens?.S);
            }else{
                setIdEntita('');
                setCity('');
                setNome('');
                setNavilens('');
            }
        }
        init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[props.openManageFermateDialog])

    const insFermata = async() => {
        try {
        
            if(!idEntita)return;

            const data = {
                idEntita: idEntita,
                nome: nome,
                navilens: navilens,
                city: props.city
            }

            const axiosParams = {
                url: '/ins-fermata',
                method: 'post',
                baseURL: config.API_URL,
                headers: { 
                    Authorization: `Bearer ${auth.sessionInfo?.accessToken}` 
                },
                data
            };

            await axios(axiosParams);
            notificationSuccess('Fermata Aggiunta');

            await props.getFermate();
            props.handleCloseManageFermateDialog();
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
        }
    }

    const modFermata = async() => {
        try {
            const data = {
                nome: nome === originalNome ? '' : nome,
                navilens: navilens === originalNavilens ? '' : navilens,
            }
            
            const dataToPass = {
                idEntita: idEntita,
                city: city,
                ExpressionAttributeNames: {},
                ExpressionAttributeValues: {},
                UpdateExpression: "SET",
            };
            
            let dataKeys = Object.keys(data);
            for (let index = 0; index < dataKeys.length; index++) {
                const element = dataKeys[index];
                
                if(!data[element]){
                    delete data[element];
                }else{
                    dataToPass.ExpressionAttributeNames['#'+element] = element
                    dataToPass.ExpressionAttributeValues[':'+element] = {"S": data[element]};
                    dataToPass.UpdateExpression = `${dataToPass.UpdateExpression} #${element}=:${element},`;
                }
            }

            if(!Object.keys(data).length){
                //se non ci sono chiavi non è cambiato nulla e ritorno
                return;
            }

            const axiosParams = {
                url: '/mod-fermata',
                method: 'post',
                baseURL: config.API_URL,
                headers: { 
                    Authorization: `Bearer ${auth.sessionInfo?.accessToken}` 
                },
                data: dataToPass
            };

            const response = await axios(axiosParams);
            notificationSuccess('Fermata Aggiornata');

            let newOriginalItems = response.data.responseUpdate.Attributes

            setOriginalNome(newOriginalItems?.nome?.S || '');
            setOriginalNavilens(newOriginalItems?.navilens?.S || '');

            await props.getFermate();
            props.handleCloseManageFermateDialog();
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error.response.data.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
        }
    }

    return (
        <Dialog className="dialog-mod-fermata" open={props.openManageFermateDialog} onClose={props.handleCloseManageFermateDialog} PaperComponent={PaperComponent} >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">{props.openManageFermateDialog === 'ins' ? 'Inserisci fermata' : props?.lastCellData?.nome?.S + ' - ' + props?.lastCellData?.idEntita?.S}</DialogTitle>
            <DialogContent>
                <div className='dialog-fermata-wrapper'>
                    <div className='dialog-fermata-wrapper-section'>
                        {(props.openManageFermateDialog==='ins')&&(<div className="dialog-fermata-fields">
                            <TextField
                                className="dialog-identita required-field-bg"
                                id="dialog-identita"
                                label="Id Fermata"
                                type="text"
                                value={idEntita}
                                onChange={(event) => {
                                    if(inputOnlyNumbers(event.target.value))setIdEntita(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "100%",
                                    maxWidth: "100px"
                                }}
                            />
                        </div>)}
                        <div className="dialog-fermata-fields">
                            <TextField
                                className="dialog-nome required-field-bg"
                                id="dialog-nome"
                                label="Nome"
                                type="text"
                                value={nome}
                                onChange={(event) => {
                                    setNome(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "100%"
                                }}
                            />
                        </div>
                        <div className="dialog-fermata-fields">
                            <TextField
                                className="dialog-navilens required-field-bg"
                                id="dialog-navilens"
                                label="Navilens"
                                type="text"
                                value={navilens}
                                onChange={(event) => {
                                    setNavilens(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "30%"
                                }}
                            />
                        </div>
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button variant="standard" onClick={() => props.openManageFermateDialog === 'ins' ? insFermata() : modFermata()}>
                    Salva
                </Button>
                <Button variant="outlined" autoFocus onClick={props.handleCloseManageFermateDialog}>
                    Esci
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ManageFermateDialog